import { Outlet } from 'react-router-dom';

export function ProfileLayout() {
  return (
    <main className="af-screen">
      <section className="af-shell" style={{ maxWidth: 980, paddingBottom: 72 }}>
        <Outlet />
      </section>
    </main>
  );
}
